import Vue from 'vue'

//DATATABLES
import DataTables from './components/shared/DataTables'
Vue.component('DataTables', DataTables)

//AUTOCOMPLETE
import Autocomplete from './components/shared/Autocomplete'
Vue.component('Autocomplete', Autocomplete)